import { registerNotification } from './registry'

registerNotification('script:not-started', {
  color: (_, theme) => theme.semantic.warning,
  icon:  () => 'play-circle-strikethrough',
})